
import { PropType } from 'vue';

interface CardData {
  headerIcon: string;
  headerText?: string;
  headerColor?: string; // (optional, used for the headerIcon / headerText color, default black),
  headerBackgroundColor?: string; // (optional, default white)
  cardTitle?: string;
  cardTextColor?: string; // (optional, default black)
  cardBackgroundColor?: string; // (optional, default, white)
  tooltip?: string;
  loader?: boolean;
}

export default {
  name: 'DynamicCard',
  props: {
    hoverReveal: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    cardTitle: {
      type: String,
      default: '',
    },
    cardBackgroundColor: {
      type: String,
      default: 'white',
    },
    cardTextColor: {
      type: String,
      default: 'black',
    },
    state: {
      type: Object as PropType<CardData>,
      default: () => {
        return {
          headerIcon: '',
          headerText: '',
          headerColor: 'primary',
          headerBackgroundColor: 'white',
          tooltip: '',
          loader: false,
          hoverReveal: false,
        };
      },
    },
  },
};
